const API_BASE = import.meta.env.VITE_API_URL;

/**
 * Create a SetupIntent for 3D Secure authentication (authenticated)
 * This must be called before creating a subscription for EU/Danish cards
 */
export const createSetupIntent = async (token) => {
  try {
    console.log("[Stripe API] Creating SetupIntent...");

    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(`${API_BASE}/api/stripe/create-setup-intent`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("[Stripe API] SetupIntent created:", data);
    return data;
  } catch (error) {
    console.error("[Stripe API] Failed to create SetupIntent:", error);
    throw error;
  }
};

/**
 * Create a SetupIntent for signup (unauthenticated)
 * Used during user registration before account exists
 */
export const createSetupIntentForSignup = async (email, name) => {
  try {
    console.log("[Stripe API] Creating SetupIntent for signup, email:", email);

    const response = await fetch(
      `${API_BASE}/api/stripe/create-setup-intent-signup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, name }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("[Stripe API] SetupIntent created for signup:", data);
    return data;
  } catch (error) {
    console.error(
      "[Stripe API] Failed to create SetupIntent for signup:",
      error,
    );
    throw error;
  }
};

/**
 * Get user's invoices/receipts from Stripe
 * @param {string} token - Authentication token
 * @returns {Promise<{invoices: Array}>} Array of invoices
 */
export const getInvoices = async (token) => {
  try {
    console.log("[Stripe API] Fetching invoices...");

    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(`${API_BASE}/api/stripe/invoices`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("[Stripe API] Invoices fetched:", data);
    return data;
  } catch (error) {
    console.error("[Stripe API] Failed to fetch invoices:", error);
    throw error;
  }
};
